<template>
	<div>
		<v-carousel
			:show-arrows="false"
			hide-delimiters
			height="auto"
			light
			v-model="step"
			class="flex-grow-1"
		>
			<v-carousel-item>
				<v-slider
					v-model="opacity"
					label="Peršviečiamumas"
					hide-details
				></v-slider>
				<v-checkbox
					label="Identifikavimas įgalintas"
					dense
					v-model="identifyEnabled"
					hide-details
					class="mt-1"
				></v-checkbox>
				<MapLayerTree
					class="mt-3"
					v-bind:layer="layer"
					:key="layer.service.uniqueKey"
				/>
				<div class="mt-4 pt-3 actions">
					<template v-if="layer.service.meta">
						<LikeOrUnlikeButton
							:service="layer.service.meta"
						/>
						<v-btn
							icon
							v-on:click="showInfo"
						>
							<v-icon title="Informacija">mdi-information-outline</v-icon>
						</v-btn>
					</template>
					<v-btn
						icon
						v-on:click="zoomTo"
						:disabled="false"
						:loading="zoomToLoading"
					>
						<v-icon title="Rodyti aprėptį">mdi-arrow-expand-all</v-icon>
					</v-btn>
					<v-btn
						icon
						v-on:click="remove"
					>
						<v-icon title="Pašalinti">mdi-delete-forever</v-icon>
					</v-btn>
				</div>
			</v-carousel-item>
			<v-carousel-item>
				<template v-if="layer.service.meta">
					<Back title="Grįžti į sluoksnio informacijos skiltį" :action="showMainScreen" />
					<MapLayerAttributes :meta="layer.service.meta" :filter="true" />
				</template>
			</v-carousel-item>
		</v-carousel>
	</div>
</template>

<script>
	import MapLayerTree from "./MapLayerTree";
	import LikeOrUnlikeButton from "./LikeOrUnlikeButton";
	import Back from "../../../../../../components/Back";
	import MapLayerAttributes from "../../../../../../components/MapLayerAttributes";
	import {containsExtent, isEmpty} from "ol/extent";
	import MapHelper from "../../../../../../components/helpers/MapHelper";
	import {boundingExtent} from "ol/extent";

	export default {
		props: {
			layer: Object,
			myMap: Object,
			removeLayer: Function
		},
		data: function(){
			var identifyEnabled = true;
			if (typeof this.layer.service.identifyEnabled !== "undefined") {
				identifyEnabled = this.layer.service.identifyEnabled;
			}
			var data = {
				opacity: 100 - this.layer.get("opacity")*100,
				step: 0,
				identifyEnabled: identifyEnabled,
				zoomToLoading: false
			};
			return data;
		},
		components: {
			MapLayerTree,
			LikeOrUnlikeButton,
			Back,
			MapLayerAttributes
		},
		watch: {
			opacity: {
				handler(newValue) {
					this.layer.set("opacity", 1 - newValue/100);
				}
			},
			identifyEnabled: {
				immediate: true,
				handler: function(identifyEnabled){
					this.layer.service.identifyEnabled = identifyEnabled;
				}
			}
		},
		methods: {
			remove: function(){
				this.removeLayer(this.layer);
			},
			zoomTo: function(){
				var extent = MapHelper.getExtent(this.layer.service);
				if (!extent) {
					if (this.layer.getSource()) {
						extent = this.layer.getSource().getExtent(); // Pvz. vektoriniams sluoksniams sprendimas tiko... FIXME! O gal šis sprendimas klaidinantis: jei tik dalį viso duomenų rinkinio objektų čia turime?..
						if (extent && isEmpty(extent)) {
							extent = null;
						}
					}
				}
				if (extent) {
					var fullExtent = this.myMap.getFullExtent();
					if (!containsExtent(fullExtent, extent)) {
						extent = fullExtent;
					}
					this.myMap.map.getView().fit(extent, this.myMap.map.getSize());
				} else {
					if (this.layer.service.type == "edvi-vector") {
						this.zoomToEdviLayer(this.layer);
					}
					console.warn("No extent?!");
				}
			},
			showInfo: function(){
				this.step = 1;
				console.log("SHOW INFO!", this.layer.service.meta);
			},
			showMainScreen: function(){
				this.step = 0;
			},
			zoomToEdviLayer: function(layer){
				this.zoomToLoading = true;
				var params = {
					where: "1=1",
					f: "json",
					returnGeometry: true,
					outSR: 3346
				};
				var promise = new Promise(function(resolve, reject){
					var url = layer.service.url + "/query?" + new URLSearchParams(params).toString();
					window.fetch(url, {
						method: "GET",
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var json;
						if (text) {
							try {
								json = JSON.parse(text);
							} catch(err) {
								// ...
							}
						}
						if (json) {
							resolve(json);
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this));
				promise.then(function(json){
					if (json && json.features) {
						var coordinates,
							coordinatesUnion = [];
						json.features.forEach(function(feature){
							coordinates = this.getCoordinates(feature.geometry);
							if (coordinates) {
								coordinatesUnion = coordinatesUnion.concat(coordinates);
							}
						}.bind(this));
						if (coordinatesUnion.length) {
							var extent = boundingExtent(coordinatesUnion);
							this.myMap.map.getView().fit(extent, this.myMap.map.getSize());
						}
					}
					this.zoomToLoading = false;
				}.bind(this), function(){
					this.zoomToLoading = false;
				}.bind(this));
			},
			getCoordinates: function(geometry){
				var coordinates = [];
				if (geometry) {
					if (geometry.rings) {
						geometry.rings.forEach(function(ring){
							ring.forEach(function(c){
								coordinates.push(c);
							});
						});
					} else if (geometry.paths) {
						geometry.paths.forEach(function(path){
							path.forEach(function(c){
								coordinates.push(c);
							});
						});
					} else if (geometry.x && geometry.y) {
						coordinates.push([geometry.x, geometry.y]);
					}
				}
				return coordinates;
			}
		}
	}
</script>

<style scoped>
	.actions {
		border-top: 1px solid #cccccc;
	}
</style>